import React, { FC, PropsWithChildren, useState, useMemo, useCallback } from 'react';

import { PopupGroupContextValue } from './PopupGroup.types';
import { PopupGroupContext } from './PopupGroupContext';

interface Props {
    onPopupToggle?: (hasOpenedPopup: boolean) => void;
}

const PopupGroup: FC<PropsWithChildren<Props>> = ({ children, onPopupToggle }) => {
    const [currentPopupId, setCurrentPopupId] = useState<string | null>(null);
    const registerPopup: PopupGroupContextValue['registerPopup'] = useCallback(
        (id) => {
            setCurrentPopupId(id);
            // eslint-disable-next-line no-unused-expressions
            onPopupToggle?.(!!id);
        },
        [onPopupToggle]
    );
    const contextValue: PopupGroupContextValue = useMemo(
        () => ({
            currentPopupId,
            registerPopup,
        }),
        [currentPopupId, registerPopup]
    );

    return <PopupGroupContext.Provider value={contextValue}>{children}</PopupGroupContext.Provider>;
};

export default PopupGroup;
